import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=1db6c90c&scoped=true"
import script from "./Liquid.vue?vue&type=script&lang=js"
export * from "./Liquid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db6c90c",
  null
  
)

export default component.exports